import { useEffect, useState } from 'react';
import logConfig, { getLogSearchFields } from './constants';
import { LogFields, LogTypeEnum } from '../../types/log';

const filterInlineField = (field: string) => {
  const hasInline =
    localStorage.getItem('hasInlineServices') === 'true' ? true : false;
  return !(field === 'smtpSender' && !hasInline);
};
const filterSmexField = (field: string) => {
  const globalSettings = JSON.parse(
    localStorage.getItem('casCurOrgGlobalSetting') || '{}'
  );
  return !(
    field === 'productServerName' && !globalSettings.smexHybridFeatureShow
  );
};

const filterWritingStyleField = (field: string) => {
  const globalSettings = JSON.parse(
    localStorage.getItem('casCurOrgGlobalSetting') || '{}'
  );
  return !(
    field === 'mergedWritingStyleCompromisedSender' &&
    !globalSettings.writingStyleFeatureShow
  );
};

const filterUrlSandboxField = (field: string) => {
  const globalSettings = JSON.parse(
    localStorage.getItem('casCurOrgGlobalSetting') || '{}'
  );
  return !(field === 'ddaaasScanType' && !globalSettings.urlSandboxFeatureShow);
};

export const useLogFields = (logType: LogTypeEnum) => {
  const [logFields, setLogFields] = useState<LogFields>({
    searchFields: [],
    facetsFields: [],
    showFields: [],
    mergedFields: {},
    wrapFields: [],
  });

  useEffect(() => {
    const allSearchFields = getLogSearchFields();
    const ret = {
      searchFields: allSearchFields[logType]
        .filter((field) => filterInlineField(field.field))
        .filter((field) => filterSmexField(field.field))
        .filter((field) => filterWritingStyleField(field.field))
        .filter((field) => filterUrlSandboxField(field.field)),

      facetsFields: logConfig[logType].facets
        .filter(filterInlineField)
        .filter(filterSmexField)
        .filter(filterWritingStyleField)
        .filter(filterUrlSandboxField),

      showFields: logConfig[logType].showFields
        .filter(filterInlineField)
        .filter(filterSmexField)
        .filter(filterWritingStyleField)
        .filter(filterUrlSandboxField),

      // showFields: logConfig[logType].showFields,
      mergedFields: logConfig[logType].mergedFields,
      wrapFields: logConfig[logType].wrapFields,
    };
    setLogFields(ret);
  }, [logType]);

  return logFields;
};
